import { Dispatch } from 'redux'
import {
  apiRequest,
  apiFailure,
  getCategories as getCategoriesReducer,
  setActiveCategory as setActiveCategoryReducer,
} from 'reducers/categories.reducer'
import { categoriesService } from 'services/categories.service'
import ICategory from 'models/ICategory'

export const getCategories = (slug: string) => async (dispatch: Dispatch) => {
  try {
    dispatch(apiRequest())

    const response = await categoriesService.getCategories(slug)
    if (response) {
      dispatch(
        getCategoriesReducer({ categories: response.data as ICategory[] })
      )
    }
  } catch (error) {
    dispatch(apiFailure())
  }
}

export const setActiveCategory =
  (activeCategory: number) => (dispatch: Dispatch) => {
    dispatch(
      setActiveCategoryReducer({ activeCategory: activeCategory as number })
    )
  }
